<div class="d-flex flex-column surface-high-contrast cashin-container">
  <ngx-app-bar
    class="w-100"
    [title]="' واریز به ' + state().walletTitle"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  <div class="d-flex flex-column align-items-center py-big surface-elevated p-medium">
    <wealth-applet-wallet-payable-info
      class="w-100 d-flex"
      [uncollectible]="state().walletUncollectibleBalance"
      [withdrawalBalance]="state().walletWithdrawableBalance"
      [walletName]="state().walletTitle"
    />

    <wealth-applet-wallet-amount-form
      class="w-100 cashin-content"
      [ngClass]="{
        'cashin-content-max-heigh': state().hasTransactions,
        'cashin-content-with-checkbox-max-heigh': !state().hasTransactions,
      }"
      [minAmount]="state().minAmount"
      [maxAmount]="state().maxAmount"
      [amount]="this.state().amount"
      [type]="'cashIn'"
      [title]="'مبلغ افزایش موجودی را وارد کنید.'"
      (amountChange)="amountChange($event)"
    />

    <div class="w-100 cashin-buttons d-flex flex-wrap surface-elevated">
      <div class="w-100 d-flex">
        <ngx-callout
          class="w-100"
          [title]="'نکات مهم'"
          [mode]="'multiple'"
          [messages]="[
            'واریز فقط از طریق کارت بانکی خودتان امکان پذیر است.',
            'حداقل موجودی مورد نیاز برای درخواست اعتبار ۳ میلیون تومان است.',
          ]"
        />
      </div>

      @if (!state().hasTransactions) {
        <ngx-checkbox
          class="align-items-center mt-small"
          (checkedChange)="onToggleAgreement($event)"
          [checked]="agreementChecked()"
        >
          <div class="d-flex gap-tiny check-box-text">
            <span>شرایط</span>
            <span
              (click)="agreementView(pdfType.REGULATIONS)"
              class="text-onback-brand"
            >
              قوانین و مقررات
            </span>
            <span>را می‌پذیرم.</span>
          </div>
        </ngx-checkbox>
      }

      <ngx-button
        [buttonId]="state().walletName + '_CASH_IN'"
        class="mt-medium"
        [style]="'fill'"
        [fullWidth]="true"
        [mode]="'form'"
        size="medium"
        [disabled]="!agreementChecked() || !isValid() || btnLoading()"
        (clickHandler)="cashin()"
        [isLoading]="btnLoading()"
      >
        تایید و ادامه
      </ngx-button>
    </div>
  </div>
</div>
